import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';

import Clearfix from '../clearfix';
import { connect } from 'react-redux';

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const LookuplistItems = (props) => {
  const { placeholder, label, lookupitems, lookupListId, fieldForm } = props;
  const { form, name, option } = fieldForm;

  const options = (lookupitems[lookupListId] || []).map((item) => ({
    key: item._id,
    value: item._id,
    label: item.Name,
  }));

  options.unshift({
    key: null,
    value: undefined,
    label: '-- Select --',
  });

  let getFieldProps;
  if (form) getFieldProps = form.getFieldProps(name, option);
  return (
    <Container>
      <span>{label}</span>
      {label && <Clearfix width={8} />}
      <div style={{ flex: 1 }}>
        <Select
          isClearable
          placeholder={placeholder}
          options={options}
          classNamePrefix='react-select-custom'
          {...getFieldProps}
        />
      </div>
    </Container>
  );
};

LookuplistItems.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  lookupListId: PropTypes.string.isRequired,
};

LookuplistItems.defaultProps = {
  label: '',
  placeholder: '-- Select --',
};

export default connect((state) => ({
  lookupitems: state.lookupitems.lookupitems,
}))(LookuplistItems);



// WEBPACK FOOTER //
// ./src/components/elements/select-lookuplist-items/index.js